import { NgModule } from '@angular/core';

import { OrderAccountModule } from './orderAccount';
import { OrderConfirmationHeroHeaderModule } from './orderConfirmationHeroHeader';
import { OrderConfirmationMarkModule } from './orderConfirmationMark';
import { OrderFullSummaryModule } from './orderFullSummary';
import { OrderInfoModule } from './orderInfo';
import { OrderStatusModule } from './orderStatus';
import { OrderIdModule } from './orderId';
import { OrderSummaryModule } from './orderSummary';
import { OrderAddVoucherModule } from './orderAddVoucher';
import { ReorderWizzardModule } from './reorderWizzard';

const toExport = [
    OrderAccountModule,
    OrderConfirmationHeroHeaderModule,
    OrderConfirmationMarkModule,
    OrderFullSummaryModule,
    OrderInfoModule,
    OrderIdModule,
    OrderSummaryModule,
    OrderAddVoucherModule,
    ReorderWizzardModule,
    OrderStatusModule
];

@NgModule({
    imports: [
        ...toExport,
    ],
    exports: [
        ...toExport,
    ],
})
export class OrderComponentsModule { }
